// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2IDlQ","large":"styles_large__wvqrB"};